import React from "react";
import { Modal } from "react-bootstrap";

const CustomModal = ({
  show,
  onHide,
  title,
  children,
  size = "lg",
  dialogClassName,
}) => {
  return (
    <Modal
      id="view"
      size={size}
      show={show}
      onHide={onHide}
      dialogClassName={dialogClassName}
      backdrop="static"
      aria-labelledby="custom-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="custom-modal">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
